export default "__VITE_ASSET__Dw8xL2Nm__"